import * as React from 'react';

export type ICreatePartnerBoxContext = {
  id?: string;
  onSucceed: () => void;
  onCancel: () => void;
};

const defaultValues: ICreatePartnerBoxContext = {
  onSucceed: () => {},
  onCancel: () => {},
};

export const CreatePartnerBoxContext = React.createContext<ICreatePartnerBoxContext>(defaultValues);

export const CreatePartnerBoxProvider: React.FC<Partial<ICreatePartnerBoxContext>> = ({ children, id, onSucceed = defaultValues.onSucceed, onCancel = defaultValues.onCancel }) => {
  return <CreatePartnerBoxContext.Provider value={{ id, onSucceed, onCancel }}>{children}</CreatePartnerBoxContext.Provider>;
};
